export default "__VITE_ASSET__BkdOPi4j__"